import { ErrorHandler } from './../../../shared/ErrorHandler';
import { RegistrationService } from './../../../registration.service';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Search } from './../../../shared/user.model';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-approvance-grid',
  templateUrl: './approvance-grid.component.html',
  styleUrls: ['./approvance-grid.component.css']
})
export class ApprovanceGridComponent implements OnInit {

  maintitle = "Payment/Receipt Approval";
  title="Payment/Receipt Approval";

  isSearch: boolean;  
  itemsPerPage: number=5;
  totalItems: number;
  currentPage: number=1;
  expenditures:any={};
  Expenditure:any={};
  Apporoval:any={};
  s: Search;
  data: any;
  type:any;
  f:any=[];
  ExpenditureId: number;
  subAccountId : number;
  public inactive:boolean = true;
  status: any;
  statustype: any;


 
  

  constructor(private userService: RegistrationService, private router: Router, private errorHandler:ErrorHandler) 
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
   this.GetApporvalDetails(this.itemsPerPage, 1,'Pending');
  }

//get fuctnion for apporved
GetApporvalDetailsForApproval(itemsPerPage:any,pageNo:any,type:any){
  //alert('Inside');
  this.type=type;
  this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetApporvalDetailsForApproval(itemsPerPage,pageNo,type);
    this.data.subscribe(
      (response: any) => {
        this.Apporoval = response.ApprovalModel;
          this.totalItems = response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;  
         // alert(response.TotalItemsCount);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

    }

   //GetAllApprovalForReject
   GetAllApprovalForReject(itemsPerPage:any,pageNo:any,type:any){
      this.type=type;
      this.isSearch = false;
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetAllApprovalForReject(itemsPerPage,pageNo,type);
        this.data.subscribe(
          (response: any) => {
            this.Apporoval = response.ApprovalModel;
              this.totalItems = response.TotalItemsCount;
              this.itemsPerPage = itemsPerPage;
              this.currentPage = pageNo;  
              //alert(response.TotalItemsCount);
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
         }

//on search for Approval 
//onSearch(s, itemsPerPage: number, pageNo: number,type:any) 
onSearch(s, itemsPerPage: number, pageNo: number){
  this.isSearch = true;
  let searchText = this.s.SearchText;
  let searchCriteria = this.s.SearchCriteria;
  if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
    swal("Warning!", "Please enter the search criteria and search text.", "warning");
  else {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.onSearchApproval(searchCriteria, searchText, itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          if(data.ApprovalModel.length!=0){              
          this.Apporoval = data.ApprovalModel;
          this.totalItems = data.TotalItemsCount;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";

          //this.s.SearchText="";
          //this.s.SearchCriteria="";
        }
        else
        {
        document.getElementById('loader-spinner').style.display = "none";         
        }
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
  }
}



  //get fuction for pending
  GetApporvalDetails(itemsPerPage:any,pageNo:any,type:any){
//     ;
// alert('ExpenditureId');
    this.ExpenditureId = this.ExpenditureId;
    this.type=type;
    //alert('Inside');
    // this.isSearch = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetApporvalDetails(itemsPerPage,pageNo,type);
      this.data.subscribe(
        (response: any) => {
          this.Apporoval = response.ApprovalModel;
            this.totalItems = response.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;  
            //alert(response.TotalItemsCount);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
      }


  closeModalDialog(){
    $("#ApprovalModal").modal('hide'); 
   }



    edit(FORM:NgForm){
      FORM.value.ExpenditureId = this.ExpenditureId;  
      this.data = this.userService.updateExpenditure(FORM.value.ExpenditureId, FORM.value.Ex_Status,FORM.value.Note);
      this.data.subscribe(
        (response) => {
          FORM.reset();
          FORM.resetForm();       
          swal('Success!', ' updated Successfully .', 'success');
          this.closeModalDialog();
          this.GetApporvalDetails(this.itemsPerPage, 1,'Pending');
          //$('#bd-example-modal-lg').modal('hide');              
          //this.closeModalEvent.emit(false); 
          document.getElementById('loader-spinner').style.display = "none";
          //this.router.navigate(['/home/fir/']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
  
    }


// UpdateById(ExpenditureId)
// {
// //  value.ExpenditureId = this.ExpenditureId;
//   this.data = this.userService.UpdateById(this.ExpenditureId);
//   this.data.subscribe(
//     (response: any) => {
//     this.Documentlist = response.Result;
//     console.log('Documentlist');
//       console.log(this.Documentlist);
//     })
//   }


      pageChanged(pageNumber: number) {
        if (this.isSearch)
          // this.onSearch(this.s, this.itemsPerPage, pageNumber,this.type);
          this.onSearch(this.s, this.itemsPerPage, pageNumber);
        else
          this.GetApporvalDetails(this.itemsPerPage, pageNumber,this.type);
      }
    
      itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
        if (this.isSearch)
          //this.onSearch(this.s, this.itemsPerPage, pageNo,this.type);
          this.onSearch(this.s, this.itemsPerPage, pageNo);
        else
          this.GetApporvalDetails(this.itemsPerPage, pageNo,this.type);
      }


      // GetId(Id){
      //   ;      
      //   this.ExpenditureId = Id;
      // }



    GetId(Id,exstatus){    
      this.ExpenditureId = Id;
      this.status=exstatus;
      if(this.type!='Pending')
      {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetExpenditureStatusById(this.ExpenditureId);
      this.data.subscribe(
        (response: any) => {
          this.inactive = false;
          this.f= response[0];
          console.log('byId',response);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
    }
  }



  ClearSearch(type)
  {
    ;
    this.statustype=type;
    if(this.statustype='pending')
    this.GetApporvalDetails(this.itemsPerPage, 1,'Pending');
    else if(this.statustype='Approved')
    this.GetApporvalDetailsForApproval(this.itemsPerPage, 1,'Approved')
    else if(this.statustype='Reject')
    this.GetAllApprovalForReject(this.itemsPerPage, 1,'Reject')
  }

  }





// WEBPACK FOOTER //
// ./src/app/finance/approvance/approvance-grid/approvance-grid.component.ts